"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asTestableFilterByGroup = exports.TestableFilterByGroup = void 0;

var lodash_1 = require("lodash");

var fclasses_1 = require("@bodiless/fclasses");

var FilterByGroupClean_1 = __importDefault(require("./FilterByGroupClean"));

var asTestableFilterByGroup = fclasses_1.withDesign({
  Wrapper: fclasses_1.addProps({
    'data-filter-by-group': 'wrapper'
  }),
  FilterWrapper: fclasses_1.addProps({
    'data-filter-by-group': 'filter-wrapper'
  }),
  FilterHeader: fclasses_1.addProps({
    'data-filter-by-group': 'filter-header'
  }),
  FilterTitle: fclasses_1.addProps({
    'data-filter-by-group': 'filter-title'
  }),
  ContentWrapper: fclasses_1.addProps({
    'data-filter-by-group': 'content-wrapper'
  }),
  ResetButton: fclasses_1.addProps({
    'aria-label': 'Reset Button'
  }),
  Filter: fclasses_1.withDesign({
    TagList: fclasses_1.withDesign({
      Title: lodash_1.flow(fclasses_1.withDesign({
        FilterInputWrapper: fclasses_1.addProps({
          'data-filter-by-group': 'filter-input-wrapper'
        }),
        FilterGroupItemInput: fclasses_1.addProps({
          'aria-label': 'Radio Button Select'
        }),
        FilterGroupItemPlaceholder: fclasses_1.addProps({
          'data-filter-by-group': 'filter-tag-placeholder'
        }),
        FilterGroupItemLabel: fclasses_1.addProps({
          'data-filter-by-group': 'filter-tag-label'
        })
      })),
      Wrapper: fclasses_1.addProps({
        'data-filter-by-group': 'filter-group-wrapper'
      })
    }),
    CategoryList: fclasses_1.withDesign({
      Title: fclasses_1.addProps({
        'data-filter-by-group': 'filter-category'
      })
    })
  })
});
exports.asTestableFilterByGroup = asTestableFilterByGroup;
var TestableFilterByGroup = lodash_1.flow(asTestableFilterByGroup)(FilterByGroupClean_1.default);
exports.TestableFilterByGroup = TestableFilterByGroup;
exports.default = TestableFilterByGroup;